import { useMutation, useQuery } from '@tanstack/react-query';

import useUserPid from '@/features/auth/hooks/use-user-pid';
import type { UserPid } from '@/features/auth/services/oidc';
import { getDocument, uploadDocument } from '@/services/api/documents';

const documentQueryKey = (pid: UserPid, documentId: string | undefined) => ['documents', pid, documentId];

const useDocument = (documentId: string | undefined) => {
  const { pid } = useUserPid();

  return useQuery({
    enabled: !!documentId,
    queryFn: () => getDocument(documentId as string),
    queryKey: documentQueryKey(pid, documentId),
  });
};

const useDocumentUploadMutation = () => {
  return useMutation({ mutationFn: uploadDocument });
};

export { useDocument, useDocumentUploadMutation };
